/* esm.sh - scheduler@0.28.0 */
export * from "/*scheduler@0.28.0/esnext/scheduler.mjs";
export { default } from "/*scheduler@0.28.0/esnext/scheduler.mjs";
